import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface QuickConnectNameApplyResponse extends BackendResponse {
  item: string;
}

export interface QuickConnectNameApplyParameters extends NextApiParams {
  firstName: string;
  lastName: string;
  guid: string;
}

export const quickConnectNameApply = withNextApi<
  QuickConnectNameApplyResponse,
  QuickConnectNameApplyParameters
>("Auth/QuickConnectNameApply");
